import { mapState, mapGetters, mapActions } from 'vuex'
import mapValues from 'lodash/mapValues'
import get from 'lodash/get'
import set from 'lodash/set'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.user,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut'])

export const mapFields = (namespace, fields) => {
  return mapValues(fields, (path) => {
    return {
      get() {
        return get(this.$store.state[namespace], path)
      },
      set(value) {
        this.$store.commit(`${namespace}/updateField`, { path, value })
      },
    }
  })
}

export const updateField = (state, payload) => {
  const { path, value } = payload
  set(state, path, value)
}
